module.exports = __webpack_public_path__ + "img/iconAddressNavy.1ab4740d.svg";